/* FRIDAY CLUB — minimal theme behaviour. No libraries, no dependencies. */
(function () {
  'use strict';

  /* ── mobile navigation ──────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-nav-toggle]');
    if (!toggle) return;
    var nav = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!nav) return;
    var open = nav.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ── quantity steppers ──────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('input[type="number"]');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 0;
    var next = (parseInt(input.value, 10) || 0) + step;
    input.value = next < min ? min : next;
    // Let the cart form react to a changed line-item quantity.
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ── cart: live quantity updates ────────────────────────────────
     Without this, the steppers only change the number in the field.
     Line totals, the subtotal and any automatic discount stay stale
     until the form is submitted, which reads as a broken cart — and
     an automatic discount never shows up at all, because it is only
     calculated server-side once the cart actually changes. */

  var cartBusy = false;
  var cartTimers = {};

  function cartRoot() {
    return document.querySelector('[data-cart-root]');
  }

  function cartChangeUrl(root) {
    // root_url is "/" on the primary locale and e.g. "/de" on others.
    var base = (root.getAttribute('data-root-url') || '/').replace(/\/+$/, '');
    return base + '/cart/change.js';
  }

  function setCartBusy(root, state) {
    cartBusy = state;
    root.setAttribute('aria-busy', state ? 'true' : 'false');
    root.style.opacity = state ? '0.55' : '';
    root.style.pointerEvents = state ? 'none' : '';
  }

  function updateCartLine(line, quantity) {
    var root = cartRoot();
    if (!root) return;

    // A request is already in flight — try again once it settles.
    if (cartBusy) {
      cartTimers[line] = setTimeout(function () { updateCartLine(line, quantity); }, 200);
      return;
    }

    var sectionId = root.getAttribute('data-section-id');
    setCartBusy(root, true);

    fetch(cartChangeUrl(root), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        line: line,
        quantity: quantity,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var current = cartRoot();

        // Swap in the freshly rendered section: new line totals, new
        // subtotal, and the discount rows the server just calculated.
        var swapped = false;
        if (current && data.sections && data.sections[sectionId]) {
          var parsed = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
          var fresh = parsed.querySelector('[data-cart-root]');
          if (fresh) {
            current.innerHTML = fresh.innerHTML;
            swapped = true;
            hideCartUpdateButton();

            // Put the cursor back where it was.
            var again = current.querySelector('[data-cart-qty][data-line="' + line + '"]');
            if (again) again.focus();
          }
        }

        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = data.item_count > 0 ? ' (' + data.item_count + ')' : '';
        });

        if (current) setCartBusy(current, false);

        // No rendered section came back — never leave stale totals on
        // screen, since that is the exact failure this code exists to fix.
        if (!swapped) window.location.reload();
      })
      .catch(function () {
        // Fall back to the plain form: re-show the update button so the
        // change is not silently lost.
        var current = cartRoot();
        if (current) {
          setCartBusy(current, false);
          var btn = current.querySelector('[data-cart-update]');
          if (btn) btn.style.display = '';
        }
      });
  }

  function hideCartUpdateButton() {
    var btn = document.querySelector('[data-cart-update]');
    if (btn) btn.style.display = 'none';
  }

  if (cartRoot()) hideCartUpdateButton();

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;

    var line = input.getAttribute('data-line');
    var qty = parseInt(input.value, 10);
    if (isNaN(qty) || qty < 0) qty = 0;

    // Debounced so holding down "+" sends one request, not six.
    clearTimeout(cartTimers[line]);
    cartTimers[line] = setTimeout(function () {
      updateCartLine(parseInt(line, 10), qty);
    }, 400);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-cart-remove]');
    if (!link) return;
    e.preventDefault();
    updateCartLine(parseInt(link.getAttribute('data-line'), 10), 0);
  });

  /* ── product gallery: mobile carousel position ──────────────────
     The swiping itself is CSS scroll-snap. This only lights up the
     matching dot, and stays quiet when the gallery is a desktop grid. */
  (function () {
    var gallery = document.querySelector('[data-gallery-scroll]');
    var dots = document.querySelector('[data-gallery-dots]');
    if (!gallery || !dots) return;

    var marks = dots.querySelectorAll('span');
    var pending = false;

    gallery.addEventListener('scroll', function () {
      if (pending) return;
      pending = true;

      requestAnimationFrame(function () {
        pending = false;
        var shots = gallery.querySelectorAll('.shot');
        if (shots.length < 2) return;

        // Measured rather than assumed, so the gap stays a CSS concern.
        var step = shots[1].offsetLeft - shots[0].offsetLeft;
        if (step <= 0) return;

        var index = Math.round(gallery.scrollLeft / step);
        if (index < 0) index = 0;
        if (index > marks.length - 1) index = marks.length - 1;

        for (var i = 0; i < marks.length; i++) {
          marks[i].classList.toggle('is-active', i === index);
        }
      });
    }, { passive: true });
  })();

  /* ── variant picker ─────────────────────────────────────────────
     Options are rendered as selects. On change we look the combination
     up in the variant map printed by the section, then update the
     hidden id input, the price, the button state and the URL. */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-variant-option]');
    if (!select) return;

    var root = select.closest('[data-product]');
    if (!root) return;

    var dataEl = root.querySelector('[data-variant-json]');
    if (!dataEl) return;

    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var chosen = Array.prototype.map.call(
      root.querySelectorAll('[data-variant-option]'),
      function (s) { return s.value; }
    );

    var match = variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === chosen[i]; });
    });

    var idInput = root.querySelector('[data-variant-id]');
    var button = root.querySelector('[data-add-button]');
    var price = root.querySelector('[data-price]');
    var stock = root.querySelector('[data-stock]');

    if (!match) {
      if (button) {
        button.setAttribute('disabled', 'disabled');
        button.textContent = button.getAttribute('data-unavailable') || 'Unavailable';
      }
      return;
    }

    if (idInput) idInput.value = match.id;
    if (price) price.innerHTML = match.price_html;

    if (button) {
      if (match.available) {
        button.removeAttribute('disabled');
        button.textContent = button.getAttribute('data-default') || 'Add to cart';
      } else {
        button.setAttribute('disabled', 'disabled');
        button.textContent = button.getAttribute('data-soldout') || 'Sold out';
      }
    }

    if (stock) {
      stock.textContent = match.available
        ? (stock.getAttribute('data-in') || '')
        : (stock.getAttribute('data-out') || '');
      stock.classList.toggle('stock--out', !match.available);
    }

    // Only the signature section shows a single image that needs swapping.
    // The product page has every image on the page already.
    if (match.featured_image) {
      var main = root.querySelector('[data-gallery-main]');
      if (main) { main.src = match.featured_image; main.srcset = ''; }
    }

    if (history.replaceState && root.getAttribute('data-url')) {
      history.replaceState({}, '', root.getAttribute('data-url') + '?variant=' + match.id);
    }
  });
})();
